import './styles/index.scss';
import { RouterProvider } from 'react-router-dom';
import router from './routers';
import AppProvider from './provider/AppProvider';
import { ThemeProvider } from '@mui/material/styles';
import theme from './styles/mui_theme';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import NotificationAlert from './components/feedback/NotificationAlert';

function App() {
    return (
        <>
            <AppProvider>
                <ThemeProvider theme={theme}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <RouterProvider router={router} future={{ v7_startTransition: true }} />
                    </LocalizationProvider>
                </ThemeProvider>
                <NotificationAlert />
            </AppProvider>
        </>
    );
}

export default App;
